module.exports = __webpack_public_path__ + "media/images/referralcandy-2e4e6208277906e30f524f77d9c4df44.svg";